/** Up to two capital initials from a display name, falling back to the email's first letter. */
export function getInitials(name: string | null | undefined, email?: string | null): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length > 0) {
    const first = words[0]?.[0] ?? '';
    const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? '') : '';
    return (first + last).toUpperCase();
  }
  return (email?.trim()[0] ?? '?').toUpperCase();
}
